import { useState, useEffect } from 'react';
import s from '../styles/pages/RedeemRewards.module.css';
import site from '../data/master.json';
import RedeemLoader from '../components/redeem/RedeemLoader';
import RedeemInvalid from '../components/redeem/RedeemInvalid';
import RedeemOffer from '../components/redeem/RedeemOffer';
import RedeemCodeEntry from '../components/redeem/RedeemCodeEntry';
import RedeemSuccess from '../components/redeem/RedeemSuccess';

export default function RedeemRewards() {
  const { rewardsRedeem: ui, rewardsRedeemMock: mock } = site;
  const [stage, setStage] = useState('loading');
  const [customerData, setCustomerData] = useState(null);

  useEffect(() => {
    const stages = ['loading', 'invalid', 'expired', 'used', 'offer', 'code', 'success'];
    let i = 0;
    setCustomerData(mock);
    const interval = setInterval(() => {
      i = (i + 1) % stages.length;
      setStage(stages[i]);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className={s.container}>
      <div className={s.galleryWrap}>
        {ui.photos.map((src, i) => (
          <div key={i} className={s.galleryCell}>
            <img src={src} alt="" className={s.galleryImage} />
          </div>
        ))}
      </div>
      <div className={s.overlay} />
      <img src={site.hero.logoSrc} alt="Black Sheep" className={s.logo} />
      <div className={s.card}>
        {stage === 'loading' && <RedeemLoader ui={ui.loader} />}
        {stage === 'invalid' && <RedeemInvalid ui={ui.invalid} />}
        {stage === 'expired' && <RedeemInvalid ui={ui.expired} />}
        {stage === 'used'    && <RedeemInvalid ui={ui.used} />}
        {stage === 'offer'   && <RedeemOffer ui={ui.offer} data={customerData} onContinue={() => setStage('code')} />}
        {stage === 'code'    && <RedeemCodeEntry ui={ui.codeEntry} onSuccess={() => setStage('success')} />}
        {stage === 'success' && <RedeemSuccess ui={ui.success} data={customerData} />}
      </div>
    </div>
  );
}